export const MAX_PART_NUMBERS = 1000;
export const MAX_PART_NUMBER_LENGTH = 64;

export const SKIP_REASON = {
  EMPTY: 'empty',
  TOO_LONG: 'too long',
} as const;

export type SkipReason = (typeof SKIP_REASON)[keyof typeof SKIP_REASON];

export type PartNumberFormat = { valid: true } | { valid: false; reason: SkipReason };

export const validatePartNumberFormat = (value: string): PartNumberFormat => {
  const trimmed = value.trim();
  if (!trimmed) {
    return { valid: false, reason: SKIP_REASON.EMPTY };
  }
  if (trimmed.length > MAX_PART_NUMBER_LENGTH) {
    return { valid: false, reason: SKIP_REASON.TOO_LONG };
  }

  return { valid: true };
};
